import React from 'react';
import { TextField, useGetList, useTranslate, useGetIdentity } from 'react-admin';
import { Link } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import LightbulbIcon from '@mui/icons-material/Lightbulb';

import IconCard from '../common/IconCard';
import VoteField from 'components/suggestions/fields/VoteField';

const voteSx = {
    margin: 0,
    fontSize: 14,
    minWidth: 'auto',
    '& span': { margin: 0, display: 'flex', alignItems: 'center' },
    '& svg': { fontSize: '14px !important' }
};

const NewSuggestions = ({ data }) => {
    if (data?.length > 0) {
        return (
            <List dense sx={{ padding: 0 }}>
                {data.map(record => (
                    <ListItem
                        key={`suggestions_${record.id}`}
                        disablePadding
                        secondaryAction={<VoteField record={record} sx={voteSx} disabled />}
                    >
                        <ListItemButton component={Link} to={`/suggestions/${record.id}/show`}>
                            <ListItemText
                                primary={<TextField source="title" record={record} />}
                                secondary={record?.user?.fullname}
                                sx={{ maxWidth: '70%' }}
                            />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
        );
    }

    return null;
};

const NewSuggestionsCard = () => {
    const { data: account } = useGetIdentity();
    const { data, total } = useGetList(
        'suggestions',
        {
            pagination: { page: 1, perPage: 3 },
            sort: { field: 'id', order: 'DESC' },
            filter: { status: 'new', unvoted_by: account?.id }
        }
    );
    const translate = useTranslate();

    if (data?.length > 0) {
        return (
            <Grid size={{ xl: 3, lg: 3, sm: 6, xs: 12 }}>
                <IconCard
                    title={translate('New suggestions')}
                    icon={<LightbulbIcon />}
                    value={total}
                    content={<NewSuggestions data={data} />}
                    sx={{ height: '100%' }}
                    linkTo={`/suggestions?filter={"status":"new", "unvoted_by":${account?.id}}`}
                />
            </Grid>
        );
    }

    return null;
};

export default NewSuggestionsCard;